import moment from "moment";
import { styled, Switch } from "@monolith-forensics/monolith-ui";

import {
  DetailLabel,
  DetailValue,
  EvidenceDetailsDisplay,
  useEvidenceContext,
} from "@/Features";

import { monolithMoment } from "@/utils/date-format";

const StyledView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  .action-menu {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: flex-start;
  }
  .description-container {
    padding: 20px;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 5px;
    white-space: pre-wrap;
    font-size: 12px;
  }
  .description-header {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 12px;
    font-weight: 500;
    cursor: default;
    margin-bottom: 10px;
  }
`;

const StyledHeaderTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) =>
    theme.name === "DARK"
      ? theme.palette.text.secondary
      : theme.palette.text.primary};
`;

const StyledSubtitle = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 500;
  margin-top: 2px;
`;

export const OverviewContent: React.FC<{}> = () => {
  const {
    data: evidenceItem,
    hideEmptyFields,
    setHideEmptyFields,
  } = useEvidenceContext() || {};

  return (
    <StyledView>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 10,
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 15,
          marginTop: 15,
        }}
      >
        <div>
          <StyledHeaderTitle>
            Evidence Summary for {evidenceItem?.model_name || "Unnamed Item"} (
            {evidenceItem?.evidence_number})
          </StyledHeaderTitle>
          {evidenceItem?.updated_on && (
            <StyledSubtitle
              title={monolithMoment({
                timestamp: evidenceItem.updated_on,
                includeTime: true,
                includeZone: true,
              })}
            >
              Updated {moment.utc(evidenceItem.updated_on).fromNow()}
            </StyledSubtitle>
          )}
        </div>
        <Switch
          value={hideEmptyFields}
          onChange={(e) => setHideEmptyFields?.(e)}
          label="Hide Empty Fields"
          description="Hide empty fields from the evidence summary.  This setting persists per host."
          size="xs"
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          flex: "1 1 auto",
          overflowY: "auto",
          height: 0,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <DetailLabel>Description</DetailLabel>
          <DetailValue style={{ whiteSpace: "pre-wrap", maxHeight: "none" }}>
            {evidenceItem?.description || "No Description"}
          </DetailValue>
        </div>
        <EvidenceDetailsDisplay
          orientation="horizontal"
          style={{ marginTop: 10 }}
          dataFieldIgnoreList={["description"]}
          hideEmptyFields={hideEmptyFields}
        />
      </div>
    </StyledView>
  );
};
